import { useParams } from "react-router-dom";
import CreateNewOrder from "../../components/NewDetail/CreateNewOrder";

const CreateNewOrderForCompany = () => {
  const { companyId, projectId } = useParams();
  return <CreateNewOrder companyId={companyId} projectId={projectId} />;
};
export default CreateNewOrderForCompany;
